import { z } from 'zod';
// ── crearAllocationManualSchema — POST /vacaciones-allocations (Prompt AE) ───
// Alta manual RH/root, exclusiva para tipos 'cupon_fijo'/'permisos_especiales'
// (la validación de que el tipo NO sea 'antiguedad' vive en el servicio,
// porque depende de leer tipos_ausencia — no hay forma de saberlo solo con
// el shape de este payload). Sin ventana de 18 meses forzada — fecha_inicio/
// fecha_fin los decide RH directamente, a diferencia del backfill de
// antigüedad (que las calcula). dias_otorgados va explícito en cada alta
// (no se copia del catálogo) — para 'permisos_especiales' el catálogo trae
// 0 = "se evalúa caso por caso" (Prompt AD-2), así que el valor real se
// decide aquí, por allocation.
export const crearAllocationManualSchema = z
    .object({
    usuario_id: z.string().uuid(),
    tipo_ausencia_id: z.string().uuid(),
    fecha_inicio: z.string().date(),
    fecha_fin: z.string().date(),
    dias_otorgados: z.coerce.number().int().nonnegative(),
})
    .refine(d => d.fecha_inicio <= d.fecha_fin, {
    message: 'fecha_inicio no puede ser posterior a fecha_fin',
    path: ['fecha_fin'],
});
//# sourceMappingURL=vacaciones-allocations.js.map